import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CbpayCardexService {
  private baseUrl = environment.apiNest;

  constructor(
    private http: HttpClient,
    private cognitoService: CognitoService,
  ) {}

  private async getHeaders(): Promise<HttpHeaders> {
    const session = await this.cognitoService.getSession();
    if (!session?.accessToken?.jwtToken) {
      return new HttpHeaders().set('Content-Type', 'application/json');
    }

    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${session.accessToken.jwtToken.trim()}`);
  }

  async listCardexMovements(params: {
    page: number;
    limit: number;
    startDate?: string;
    endDate?: string;
  }) {
    const headers = await this.getHeaders();
    const queryParams: Record<string, string> = {
      page: `${params.page}`,
      limit: `${params.limit}`,
    };

    if (params.startDate) queryParams['startDate'] = params.startDate;
    if (params.endDate) queryParams['endDate'] = params.endDate;

    const serviceURL = `${this.baseUrl}cbpay-cardex?${new URLSearchParams(queryParams).toString()}`;
    return this.http.get<any>(serviceURL, { headers });
  }

  async exportCardexToExcel(params: {
    startDate?: string;
    endDate?: string;
  }): Promise<Observable<Blob>> {
    const headers = await this.getHeaders();
    const queryParams: Record<string, string> = {};

    if (params.startDate) queryParams['startDate'] = params.startDate;
    if (params.endDate) queryParams['endDate'] = params.endDate;

    const url = `${this.baseUrl}cbpay-cardex/export?${new URLSearchParams(queryParams).toString()}`;

    return new Promise((resolve) => {
      resolve(
        this.http.get(url, {
          headers,
          responseType: 'blob',
        }),
      );
    });
  }

  async getLastBalance(): Promise<Observable<any>> {
    const headers = await this.getHeaders();
    const serviceURL = `${this.baseUrl}cbpay-cardex/last-balance`;
    return new Promise((resolve) => {
      resolve(this.http.get<any>(serviceURL, { headers }));
    });
  }
}
